import { Container, SectionText } from '@/atoms';
import { Card, SwiperCustom } from '@/molecules';
import { WhatsIncluded } from '@/organisms';

import type { FunctionComponent } from 'react';
import type { TypeWhatsIncludedTemplateProps } from './types';

/**
 * WhatsIncludedTemplate
 */
export const WhatsIncludedTemplate: FunctionComponent<
  TypeWhatsIncludedTemplateProps
> = ({
  className = '',
  backgroundColorBottom,
  backgroundColorBottomMobile,
  backgroundColorTop,
  backgroundColorTopMobile,
  caption,
  cutLevel = 50,
  cutLevelMobile = 50,
  desc,
  footer,
  textColor,
  title,
  whatsIncludedProps,
  index,
  id,
  cards,
}: TypeWhatsIncludedTemplateProps) => {
  const hasCards = cards?.length > 0;
  return (
    <Container
      index={index}
      backgroundColorBottom={backgroundColorBottom}
      backgroundColorTopMobile={backgroundColorTopMobile}
      backgroundColorTop={backgroundColorTop}
      backgroundColorBottomMobile={backgroundColorBottomMobile}
      cutLevel={cutLevel === null ? 50 : cutLevel}
      cutLevelMobile={cutLevelMobile === null ? 50 : cutLevel}
      className={`flex flex-col gap-6  md:gap-10 ${className}`}
      id={id}
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      class="relative overflow-hidden"
    >
      <div className="flex w-full flex-col gap-20 md:flex-row">
        <SectionText
          title={title}
          desc={desc}
          direction={!hasCards ? 'row' : 'column'}
          textAlign="start"
          variant={textColor}
          caption={caption}
          className={`${hasCards ? 'min-w-[50%] md:w-1/2' : ''} w-full `}
        />
        {hasCards && (
          <div className="relative overflow-hidden pr-20 md:absolute md:left-1/2 md:ml-8 md:w-1/2">
            <SwiperCustom
              slideMaxWidth={300}
              gap={20}
              scrollbar
              navigation
              slidesPerView="auto"
              // slidesPerViewTablet={1.5}
              slidesPerViewMobile={1}
              className="relative w-full !overflow-x-visible"
              navigationClassName="!ml-0"
            >
              {cards.map((card, index) => (
                <Card
                  key={index}
                  backgroundColor={card.bgColor}
                  width={300}
                  multimediaProps={{ image: card.image }}
                  className="h-full"
                >
                  <span
                    className={`${
                      process.env.NEXT_PUBLIC_DOMAIN === 'apartments'
                        ? 'text-black'
                        : 'text-primary'
                    }`}
                  >
                    {card.description}
                  </span>
                </Card>
              ))}
            </SwiperCustom>
          </div>
        )}
      </div>
      <WhatsIncluded
        {...whatsIncludedProps}
        footer={footer}
        variant={textColor}
      />
    </Container>
  );
};

WhatsIncludedTemplate.displayName = 'WhatsIncludedTemplate';
